import { render } from "./ProfilEinstellungen.vue?vue&type=template&id=4cd10026&ts=true"
import script from "./ProfilEinstellungen.vue?vue&type=script&lang=ts"
export * from "./ProfilEinstellungen.vue?vue&type=script&lang=ts"

import "./ProfilEinstellungen.vue?vue&type=style&index=0&id=4cd10026&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__